export default {
      id: "reference-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#reference-usage",
      toString: function () {
        return this.url;
      }
    }